export default "__VITE_ASSET__hvTUhcBH__"